import section from './section';

const composers = { section };

export default composers;
